var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayerTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "59px",
    viewBox: "0 0 54 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "player-two") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "player-two",
    transform: "translate(27.000000, 29.500000) scale(-1, 1) translate(-27.000000, -29.500000) "
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    fill: "#000000",
    cx: 27,
    cy: 27,
    r: 27
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-40",
    fill: "#000000",
    cx: 27,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    fill: "#FFCE67",
    cx: 27,
    cy: 27,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(19.000000, 17.000000)",
    stroke: "#000000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,26.75 C12.627417,26.75 18,21.377417 18,14.75 C18,8.122583 12.627417,2.75 6,2.75",
    id: "Oval-Copy-11",
    transform: "translate(12.000000, 14.750000) rotate(90.000000) translate(-12.000000, -14.750000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(9.750000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 5.9844035,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 5.9844035,
    id: "Path-Copy"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerTwo);
export default __webpack_public_path__ + "static/media/player-two.3808ca69d8458efbdca19bd10962ae09.svg";
export { ForwardRef as ReactComponent };